export const texts = [
    [
        {
          text: 'You are Pressure',
          count: 100,
          fontSize: 100,
        },
        {
          text: 'Pushing me',
          count: 300,
          fontSize: 125,
        },
        {
          text: 'Crushing me',
          count: 500,
          fontSize: 150,
        },
        {
          text: 'When will you stop?',
          count: 700,
          fontSize: 125,
        },
        {
          text: 'Will you ever stop?',
          count: 900,
          fontSize: 150,
        },
        {
          text: 'Why do this?',
          count: 1100,
          fontSize:  175,
        },
        {
          text: 'Look what you\'ve done to me',
          count: 1300,
          fontSize: 100,
        },
        {
          text: 'I\'m a mess',
          count: 1500,
          fontSize: 200,
        },
        {
          text: '...',
          count: 1700,
          fontSize: 300,
        },
        {
          text: 'ok',
          count: 1900,
          fontSize: 400,
        },
        {
            text: '',
            count: 2100,
            fontSize: 400,
          },
      ],
      [
        {
          text: 'You Win',
          count: 100,
          fontSize: 125,
        },
        {
          text: 'You cut through me',
          count: 300,
          fontSize: 100,
        },
        {
          text: 'Sharp and jagged',
          count: 500,
          fontSize: 120,
        },
        {
          text: 'I\'m glad you\'re here',
          count: 700,
          fontSize: 100,
        },
        {
          text: 'It just was the same without you',
          count: 900,
          fontSize: 50,
        },
        {
          text: 'I guess...',
          count: 1100,
          fontSize: 200,
        },
        {
          text: '...that\'s all you can do',
          count: 1300,
          fontSize: 75,
        },
        {
          text: 'Rip me apart',
          count: 1500,
          fontSize: 200,
        },
        {
          text: '',
          count: 1700,
          fontSize: 300,
        },
      ],
      [
        {
          text: 'See me?',
          count: 100,
          fontSize: 200,
        },
        {
          text: 'Here I am',
          count: 300,
          fontSize: 125,
        },
        {
          text: 'Hiding',
          count: 500,
          fontSize: 100,
        },
        {
          text: 'not anymore',
          count: 700,
          fontSize: 50,
        },
        {
          text: 'great',
          count: 900,
          fontSize: 10,
        },
        {
          text: '',
          count: 1100,
          fontSize: 10,
        },
      ],
      [
        {
          text: 'Actually',
          count: 100,
          fontSize: 100,
        },
        {
          text: 'Maybe',
          count: 300,
          fontSize: 125,
        },
        {
          text: 'This is nice',
          count: 500,
          fontSize: 100,
        },
        {
            text: 'Tell me something',
            count: 700,
            fontSize: 50,
          },
        {
          text: 'Am I free?',
          count: 900,
          fontSize: 25,
        },
        {
          text: 'I feel free',
          count: 1100,
          fontSize: 10,
        },
        {
          text: 'thank you',
          count: 1300,
          fontSize: 10,
        },
        {
            text: '',
            count: 1500,
            fontSize: 10,
        }
      ]
];

export default texts;